// extracted by mini-css-extract-plugin
module.exports = {"add-btn":"_2Vv6_sF6PP","btn-icon":"EI1WKXiLr1"};